import { VStack } from "@/components/ui/vstack";
import { ScrollView } from "react-native-gesture-handler";
import React from 'react';
import {useSelector} from "react-redux";
import { useWindowDimensions } from 'react-native';
import RenderHtml from 'react-native-render-html';
import Footer from "../../components/basic/Footer";
import {useSafeAreaInsets} from "react-native-safe-area-context";


export default function DataSecurity({navigation, hideFooter}) {
    const { width } = useWindowDimensions();
    const insets = useSafeAreaInsets()

    const source = useSelector((state) => state.legal.dpa_de)

    return (
        <VStack space='xs' className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 90 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3 mt-2">
                <RenderHtml contentWidth={width} source={source}/>
            </ScrollView>
            {!hideFooter && <Footer navigation={navigation} />}
        </VStack>
    );
}
